module["exports"] = [
  "/34##-######-####L/",
  "/37##-######-####L/"
];
